export const appliancesConstants = {
  DETAIL_REQUEST: "APPLIANCES_DETAIL_REQUEST",
  DETAIL_SUCCESS: "APPLIANCES_DETAIL_SUCCESS",
  DETAIL_FAILURE: "APPLIANCES_DETAIL_FAILURE",
  SET_DETAIL_ITEM: "SET_DETAIL_ITEM",
  SET_TAB: "SET_TAB"
};
